/** Living situation options (mirrors Wisconsin PCST F-11133 element 8). */
export const LIVING_SITUATION_GROUPS = [
  {
    label: "Own home or apartment",
    options: [
      ["own_alone", "Alone"],
      ["own_family", "With spouse, partner, or family"],
      ["own_roommates", "With non-relative or roommates (dormitory, convent, communal setting)"],
      ["own_paid_caregiver", "With live-in paid caregiver(s)"],
    ],
  },
  {
    label: "Someone else's home or apartment",
    options: [
      ["others_family", "Family"],
      ["others_nonrelative", "Non-relative"],
      ["others_afh_1_2", "1–2 bed adult family home (certified) or other"],
      ["others_paid_caregiver", "Paid caregiver's home"],
      ["others_provider_lease", "Home / apartment leased by a support services provider"],
    ],
  },
  {
    label: "Apartment with services",
    options: [
      ["apt_rcac", "Residential care apartment complex (RCAC)"],
      ["apt_independent_cbrf", "Independent apartment community-based residential facility (CBRF)"],
    ],
  },
  {
    label: "Group residential care setting",
    options: [
      ["group_afh_3_4", "Licensed adult family home (3–4 bed)"],
      ["group_cbrf_1_20", "CBRF with 1–20 beds"],
      ["group_cbrf_20_plus", "CBRF with more than 20 beds"],
      ["group_childrens_home", "Children's group home"],
    ],
  },
  { label: "Other", options: [["other", "Other (explain in notes)"]] },
];

export const LIVING_SITUATION_LABEL = Object.fromEntries(LIVING_SITUATION_GROUPS.flatMap((g) => g.options));

export function livingSituationLabel(code) {
  if (!code) return "";
  const group = LIVING_SITUATION_GROUPS.find((g) => g.options.some(([c]) => c === code));
  return group && group.label !== "Other" ? `${group.label} — ${LIVING_SITUATION_LABEL[code]}` : LIVING_SITUATION_LABEL[code] || code;
}
